import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Platform } from 'react-native';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const hasLiquidGlassTabBar = () => {
  if (Platform.OS !== 'ios') {
    return false;
  }
  const version = parseInt(Platform.Version as string, 10);
  return version >= 26;
};
